export const INVENTORY_CHECKLIST = "INVENTORY_CHECKLIST";
